const {getValueFromObjectByPrefix, menuFromMap, languagesMenu} = require('./../utils');
const {domains, languages} = require('./../data/constants.json');
const cssMobile = require('./header/mobile.scss');
const cssDesktop = require('./header/desktop.scss');
const {modifyBlogLink} = require('./common');

module.exports = ({map, translations, isMobile, user, config}) => {
  const t = getValueFromObjectByPrefix(translations);

  const mainLinks = menuFromMap(
    map,
    isMobile ? 'header.mobileNav' : 'header.nav',
    translations,
    config.language,
    [modifyBlogLink]
  );

  const userLinks = menuFromMap(
    map,
    'header.userNav',
    translations,
    config.language
  );

  if (user && !isMobile) {
    mainLinks.unshift({
      href: `//${domains.wix}/my-account`,
      text: t('menu_my_account')
    });
  }

  if (isMobile) {
    const contentAttrs = {};
    contentAttrs.for = cssMobile.languagesOpen;
    mainLinks.push({
      text: `<i class="${cssMobile.icon} ${cssMobile.iconGlobe}"></i>${languages[config.language]}<i class="${cssMobile.icon} ${cssMobile.iconArrowRight} ${cssMobile.iconToRight}"></i>`,
      tag: 'label',
      classes: user ? cssMobile.divider : null,
      contentAttrs
    });
    mainLinks.forEach(link => {
      if (link.important) {
        link.classes = cssMobile.important;
      }
    });

    if (user) {
      mainLinks.push({
        href: `//${domains.wix}/signout`,
        text: `<i class="${cssMobile.icon} ${cssMobile.iconLogout}"></i>${t('logout')}`
      });
    }
  }

  userLinks.push({
    tag: 'button',
    text: languages[config.language],
    subs: languagesMenu(config.supportedLanguages),
    attrs: {rel: 'languages'},
    extraContent: `<i class="${cssDesktop.icon} ${cssDesktop.iconGlobe}"></i>`
  });

  userLinks.push({
    href: `//${domains.wix}/signout`,
    text: t('logout')
  });

  return require(`./header/${isMobile ? 'mobile' : 'desktop'}`)({mainLinks, userLinks, user, t, config});
};



// WEBPACK FOOTER //
// ./templates/header.js